import { Box } from "lucide-react";
const AuthBanner = () => {
  return <div className="w-full flex items-center justify-center p-8">
      <div className="max-w-md text-center">
        <img 
          src="/logo-darkBG.png" 
          alt="Desky Logo" 
          className="h-32 w-auto mx-auto mb-4" 
        />
        <h1 className="text-4xl font-bold mb-4 text-slate-50">Track. Deliver. Simplify.</h1>
        <p className="text-lg text-slate-50">The modern package management system your hotel needs</p>
      </div>
    </div>;
};
export default AuthBanner;